module.exports = __webpack_public_path__ + "static/img/icon_partner_honda.5c4aed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_honda.png
// module id = gqR6
// module chunks = 1